module.exports = __webpack_public_path__ + "media/深入了解高分辨遥感卫星.69302b74.mp4";